module.exports = __webpack_public_path__ + "static/media/GAOFEN 3.4fa27686.czml";